// extracted by mini-css-extract-plugin
export default {"root":"Snackbar_root__8dhvc","info":"Snackbar_info__dpunD","icon":"Snackbar_icon__o-Tqa","message":"Snackbar_message__5Ceus","closeIcon":"Snackbar_closeIcon__zY2Jp"};